import React from 'react'
import { http } from '@weike/toolkit'
import Config, { MAIN_URL_CONFIG } from '../../config'
import './lihuaAppTip.css'
import { isAndroid, isIos } from '../../utils'

export class LihuaAPPTipComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.channelId = undefined
  }

  open(channelId) {
    this.setState({ isOpen: true })
    this.channelId = channelId
  }

  close() {
    this.setState({ isOpen: false })
  }

  getChannelShareInfo() {
    return http.get(`${Config.BASE_URL}/api/channel/${this.channelId}/info`).then(res => {
      const { data: { share_info } } = res
      return share_info
    })
  }

  onShare() {
    this.getChannelShareInfo().then(share_info => {
      const { share_description, share_icon, share_title } = share_info
      const shareData = {
        url: `${MAIN_URL_CONFIG.WK_PAGE_BASEURL}/channel2/${this.channelId}`,
        share_desc: share_description,
        share_icon,
        share_title
      }
      if (isIos()) {
        window.webkit.messageHandlers.LHAPP.postMessage({
          function: 'webAction',
          params: {
            type: 'share_distro_lecture',
            ...shareData
          }
        })
      } else if (isAndroid()) {
        window.LHAPP.webAction(JSON.stringify({
          type: 'share_distro_lecture',
          ...shareData
        }))
      }
    }).catch(() => {
      this.context.page.showAlert('网络错误，请重试')
    })
  }

  render() {
    return (
      <div className="lihua_app_tip_dialog" style={{display: !this.state.isOpen ? 'none' : '' }}>
        <div className="lihua_app_tip_dialog_mask" onClick={this.close.bind(this)} />
        <div className="lihua_app_tip">
          <h1 className="lihua_app_tip_title">课程学习方式</h1>
          <p>
            1、点击<strong onClick={this.onShare.bind(this)}>分享到微信</strong>，发送给自己
          </p>
          <img
            src="https://static-1253442168.file.myqcloud.com/xupload/20210617_流程1.png"
            style={{ width: 236, height: 80 }}
            alt="点击 分享到微信，发送给自己"
          />
          <p>2、点击分享的链接，在微信进行学习</p>
          <img
            src="https://static-1253442168.file.myqcloud.com/xupload/20210622_流程2.png"
            style={{ width: 236, height: 104 }}
            alt="点击分享的链接，在微信进行 学习"
          />
          <button className="lihua_app_tip_button" onClick={this.onShare.bind(this)}>
            分享到微信
          </button>
        </div>
      </div>
    )
  }

}

LihuaAPPTipComponent.contextTypes = {
  page: React.PropTypes.object
};


// WEBPACK FOOTER //
// ./src/components/lihuaAppTip/index.js